import React       from 'react';
import HiddenInput from './HiddenInput';

const ProductQuoteNumber = ({ parameters, groupName }) => {
  const name = 'product_quote_number';
  const value = parameters.get ? parameters.get(name) : parameters[name];
  return (
    <HiddenInput
      name={name}
      value={value}
      groupName={groupName} />
  );
};

ProductQuoteNumber.defaultProps = {
};

export default ProductQuoteNumber;
